import React, { useCallback } from 'react';
import { parse } from 'query-string';
import { useLocation } from 'react-router';
import {
  PAP_AFFILIATE_QUERY_PARAM,
  PAP_REFERRAL_COOKIE_NAME,
} from '@mm/constants/referrals';
import { useCookies } from 'react-cookie';
import { ambassadorMap } from './components/LoginLayout/AffiliateLanding/useAffiliateData/use-affiliate-data';

const validAmbassadorAffiliateIds = ambassadorMap.map(({ affiliateId }) =>
  affiliateId.toLowerCase(),
);

export const useAmbassadorId = () => {
  const { search } = useLocation();
  const query = parse(search);

  const queryAffiliateId = query[PAP_AFFILIATE_QUERY_PARAM] as
    | string
    | undefined;

  const [cookie, setCookies, removeCookies] = useCookies([
    PAP_REFERRAL_COOKIE_NAME,
  ]);
  const cookieAffiliateId = cookie[PAP_REFERRAL_COOKIE_NAME];

  const source = [queryAffiliateId, cookieAffiliateId]
    .filter(Boolean)
    .map(s => s.toLowerCase());

  const [affiliateId] = source.filter(id =>
    validAmbassadorAffiliateIds.includes(id.toLowerCase()),
  );

  const remove = useCallback(() => {
    try {
      localStorage.removeItem(PAP_REFERRAL_COOKIE_NAME);
    } catch (err) {
      console.log('local storage not supported');
    } finally {
      removeCookies(PAP_REFERRAL_COOKIE_NAME);
    }
  }, []);

  return { affiliateId, remove };
};
